import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroBanner from './components/HeroBanner';
import { HotUpdates, LatestUpdates } from './components/HotUpdates';
import CategoryGrid from './components/CategoryGrid';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homepageFaqs = [
  {
    question: '韩漫屋的漫画都是免费的吗？',
    answer: '是的，韩漫屋的所有漫画作品均面向用户免费开放阅读。我们致力于为漫画爱好者提供高质量的免费阅读体验，无需付费订阅即可畅享海量韩漫资源。',
  },
  {
    question: '韩漫屋的漫画更新频率如何？',
    answer: '我们每天更新超过100部漫画的新章节，确保读者能够及时追更喜爱的作品。热门作品的更新速度尤其快，通常在原著发布后24小时内即可读到最新内容。',
  },
  {
    question: '如何在韩漫屋找到想看的漫画？',
    answer: '您可以通过首页的热门排行、最新更新模块发现热门漫画，也可以通过分类页面按题材类型浏览，还可以使用搜索功能直接查找您想看的作品名称或作者。',
  },
  {
    question: '韩漫屋支持哪些设备阅读？',
    answer: '韩漫屋采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。',
  },
];

export default function Home() {
  return (
    <>
      <SEOSchema
        type="website"
        title="免费韩漫大全_好看的韩国漫画_漫画韩漫网址_韩漫在线阅读-韩漫屋"
        description="在韩漫屋通过漫画网址浏览免费韩漫大全与好看韩国漫画，并支持韩漫在线阅读，营造温馨阅读空间。"
        url="http://fkyy11.com/"
        faqs={homepageFaqs}
      />

      <Navbar />

      <main>
        <HeroBanner />
        <HotUpdates />
        <CategoryGrid />
        <LatestUpdates />
        <Testimonials />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}